import * as React from 'react';

function ChartIcon(props) {
  return (
    <svg width={50} height={50} fill='' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M11.065 7.762a8 8 0 019.697-5.827L42.11 7.258a8 8 0 015.827 9.697l-5.322 21.347a8 8 0 01-9.698 5.827l-21.347-5.322a8 8 0 01-5.827-9.698l5.323-21.347z'
        fill='url(#prefix__paint0_linear_717_867)'
      />
      <g filter='url(#prefix__filter0_bi_717_867)'>
        <path
          d='M0 20a8 8 0 018-8h22a8 8 0 018 8v22a8 8 0 01-8 8H8a8 8 0 01-8-8V20z'
          fill='#72BF44'
          fillOpacity={0.5}
        />
      </g>
      <path
        d='M28.598 27.269l-5.339 6.889a1.38 1.38 0 01-1.97.246l-5.126-4.019-4.615 5.97a1.38 1.38 0 01-2.546-.803c-.003-.31.101-.611.295-.853l5.52-7.118a1.38 1.38 0 011.954-.263l5.125 4.035 4.5-5.79a1.364 1.364 0 011.939-.279 1.41 1.41 0 01.263 1.952v.033z'
        fill='#fff'
        fillOpacity={0.9}
      />
      <defs>
        <linearGradient
          id='prefix__paint0_linear_717_867'
          x1={13}
          y1={0}
          x2={46.083}
          y2={4.279}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#4FB84E' />
          <stop offset={1} stopColor='#2A8640' />
        </linearGradient>
        <filter
          id='prefix__filter0_bi_717_867'
          x={-4}
          y={8}
          width={46}
          height={46}
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feGaussianBlur in='BackgroundImageFix' stdDeviation={2} />
          <feComposite in2='SourceAlpha' operator='in' result='effect1_backgroundBlur_717_867' />
          <feBlend in='SourceGraphic' in2='effect1_backgroundBlur_717_867' result='shape' />
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dx={0.2} dy={0.1} />
          <feGaussianBlur stdDeviation={0.5} />
          <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
          <feColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0' />
          <feBlend in2='shape' result='effect2_innerShadow_717_867' />
        </filter>
      </defs>
    </svg>
  );
}

export default ChartIcon;
